<div class="wizard__wrapper__general">
  <div class="row">
    <div class="col-xl-12 col-lg-12">
      <h2>
        <span>{{ "General information" | translate }}</span>
        <span *ngIf="experienceOrigin"><a class="origin__icon" href="{{ experienceOriginUrl }}"
            target="_blank"></a></span>
      </h2>
      <div class="btn-group btn--switcher" role="group">
        <button *ngFor="let lang of LANGUAGE | keyvalue" (click)="changeLanguage(lang.value)" [ngClass]="{
            'button--active': generalInfoByLang.language == lang.value
          }" type="button" class="btn">
          {{ lang.key }}
        </button>
        <!-- <button
          (click)="changeLanguage(LANGUAGE.EN)"
          [ngClass]="{
            'button--active': generalInfoByLang.language == LANGUAGE.EN
          }"
          type="button"
          class="btn"
        >
          EN
        </button> -->
      </div>

      <!-- Let's start with basics -->

      <div class="row">
        <div class="wizard__general__form col-xl-6">
          <h3>{{ "Let's start with basics" | translate }}</h3>
          <form class="row needs-validation" novalidate>
            <div class="form-row">
              <div class="form-floating mb-4 col-md-12">
                <input type="text" [(ngModel)]="
                    generalInfoByLang.dataByLang[
                      this.generalInfoByLang.language
                    ].title
                  " (focusout)="changeTitle($event)" class="form-control" [class.is-invalid]="errorName === true"
                  id="name" name="name" placeholder=" " maxlength="128" />

                <label for="name">{{ "Experience name" | translate }}</label>
                <div class="invalid-feedback">
                  {{ "Experience mandatory" | translate }}
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-floating col-md-12">
                <textarea type="text" [(ngModel)]="
                    generalInfoByLang.dataByLang[
                      this.generalInfoByLang.language
                    ].description
                  " (focusout)="changeDesc($event)" class="form-control" [class.is-invalid]="errorDesc === true"
                  id="description" name="description" placeholder=" " style="height: 150px;"></textarea>

                <label for="description">{{ "Experience description" | translate }}</label>
                <div class="invalid-feedback">
                  {{ "Experience desc mandatory" | translate }}
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-xl-5 offset-xl-1 tips">
          <div *ngIf="hasIssue && comments && commentInfo" class="general__tips general__tips--red">
            <div *ngFor="let comment of comments; index as i">
              <h2 *ngIf="!comment.isResolved && comment.type == 'INFO'" class="text-danger">
                {{ "You have unresolved issues" | translate }}
              </h2>
              <div *ngIf="!comment.isResolved && comment.type == 'INFO'">
                <h3>{{ "General information" | translate }}</h3>
                <p class="text-danger">{{ comment.comment }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Choose appropriate category for your experience -->

      <div class="row">
        <div class="wizard__general__category mt-5 col-xl-6">
          <h3>
            {{ "Choose appropriate category for your experience" | translate }}
          </h3>
          <p class="general__tip">
            <span></span>
            {{ "You can choose more than one category" | translate }}
          </p>
          <p *ngIf="
              generalInfoByLang.dataByLang[this.generalInfoByLang.language]
                .typeIndex == null
            " class="general__tip--red">
            {{ "You need to add a category for the experience" | translate }}
          </p>
          <div class="experience__categories clearfix">
            <span [ngClass]="{
                active:
                  generalInfoByLang.dataByLang[this.generalInfoByLang.language]
                    .typeIndex == i
              }" class="experience__categorie" (click)="
                selectExperienceType(cat.key, i); cat.clicked = !cat.clicked
              " *ngFor="let cat of categories; index as i">{{ cat.name | translate }}</span>
          </div>
        </div>
      </div>

      <!-- When is it going to happen -->

      <div class="row">
        <div class="wizard__general__calendar mt-3 col-xl-6">
          <h3>{{ "When is it going to happen" | translate }}</h3>
          <p class="general__tip">
            <span></span>{{ "You can add multiple time frames" | translate }}
          </p>
          <p *ngIf="
              !(
                generalInfoByLang.dataByLang[this.generalInfoByLang.language]
                  ?.scheduleExperience?.length > 0
              )
            " class="general__tip--red">
            {{ "You need to add a schedule for the experience" | translate }}
          </p>
          <div *ngIf="
              generalInfoByLang.dataByLang[this.generalInfoByLang.language]
                ?.scheduleExperience
            ">
            <div *ngFor="
                let exp of generalInfoByLang.dataByLang[
                  this.generalInfoByLang.language
                ]?.scheduleExperience;
                let i = index
              ">
              <div class="datebox__wrapper clearfix">
                <div (click)="selectSchedule(exp, i)" class="datepicker__datebox">
                  <span class="icon"></span>
                  <div class="datepicker__datebox__time__wrap">
                    <label>{{ "Start" | translate }}</label>
                    <span>{{ exp.startHour }}, {{ exp.startDateDay }}
                      {{ exp.startDateMonth | translate }}</span>
                  </div>
                </div>
                <div (click)="selectSchedule(exp, i)" class="datepicker__datebox">
                  <span class="icon"></span>
                  <div class="datepicker__datebox__time__wrap">
                    <label>{{ "end" | translate }}</label>
                    <span>{{ exp.endHour }}, {{ exp.endDateDay }}
                      {{ exp.endDateMonth | translate }}</span>
                  </div>
                </div>
                <span class="datepicker__close" (click)="removeSchedule(exp, i)">+</span>
              </div>
            </div>
          </div>

          <div (click)="onClickAddNewSchedule()" class="datebox__wrapper clearfix">
            <div class="datepicker__datebox">
              <span class="icon"></span>
              <div class="datepicker__datebox__time__wrap">
                <label>{{ "Start" | translate }}</label>
                <span>{{ "Your start date" | translate }}</span>
              </div>
            </div>
            <div class="datepicker__datebox">
              <span class="icon"></span>
              <div class="datepicker__datebox__time__wrap">
                <label>{{ "end" | translate }}</label>
                <span>{{ "Your end date" | translate }}</span>
              </div>
            </div>
            <span class="datebox__add"><span>+</span></span>
          </div>
          <app-datepicker *ngIf="toogleDatepicker" [fromDate]="fromDate" [toDate]="toDate" [timeFrom]="timeFrom"
            [timeTo]="timeTo" [weekDays]="weekDays" [weekDayString]="weekDayString"
            [editScheduleIsLoaded]="editScheduleIsLoaded"
            (onDoneSchedule)="onClickDoneSchedule($event)"></app-datepicker>
        </div>
        <div class="col-xl-5 offset-xl-1 tips">
          <div *ngIf="hasIssue && comments && commentSchedule" class="general__tips general__tips--red">
            <div *ngFor="let comment of comments; index as i">
              <h2 *ngIf="!comment.isResolved && comment.type == 'SCHEDULE'" class="text-danger">
                {{ "You have unresolved issues" | translate }}
              </h2>
              <div *ngIf="!comment.isResolved && comment.type == 'SCHEDULE'">
                <h3>{{ "Schedule information" | translate }}</h3>
                <p class="text-danger">{{ comment.comment }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>